import { createSignal } from 'solid-js';

// App state the shared components need, kept here so no component ever imports
// from an app. Each app re-exports these from its own store, or pushes into the
// setter when its value changes. Defaults are chosen so a component still
// renders sensibly in an app that has wired nothing.

// Display density, read by Divider.
export type SpacingId = 'regular' | 'minimal';

export const [spacing, setSpacing] = createSignal<SpacingId>('regular');

// The proportional bars behind ListRow. 'none' turns every bar off at once.
export type MetricBarVariant = 'fill' | 'none';

export const [metricBarVariant, setMetricBarVariant] = createSignal<MetricBarVariant>('fill');

// VirtualizedTable warms the rows adjacent to the one you navigate to, when the
// app supplies a way to do it. Left as a plain module variable rather than a
// signal: it is called imperatively from an event handler, and a signal holding
// a function invites the updater-callback footgun.
export type PrefetchNearby = <T>(rows: readonly T[], index: number, getSymbol: (row: T) => string | null | undefined, count?: number) => void;

const noop: PrefetchNearby = () => {};

let prefetchNearbyImpl: PrefetchNearby = noop;

export const setPrefetchNearby = (fn: PrefetchNearby): void => {
    prefetchNearbyImpl = fn;
};

export const prefetchNearby: PrefetchNearby = (rows, index, getSymbol, count) => prefetchNearbyImpl(rows, index, getSymbol, count);
